export default __webpack_public_path__ + "static/media/teamAni5.7d32f24f.gif";